// Components==============
import Layout from 'components/Layout';
import Container from 'components/UI/Container';
import HeroLayout from 'components/UI/HeroLayout';
import React, { useEffect } from 'react';
import './index.module.scss';
import indexPage from 'actions/page/index';
import { useDispatch } from 'react-redux';
// =========================

export default function Page() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(indexPage());
    }, []);

    return (
        <Layout>
            <Container>
                <HeroLayout />
            </Container>
        </Layout>
    );
}
